import React, { useContext } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import { Loading } from './loading'

export const LogoutCallback = () => {
  const { signoutRedirectCallback } = useContext(AuthContext)
  signoutRedirectCallback()
  return <Loading />
}
